import React, { useEffect, useState } from "react";
import { getJoinCodeByTeamId } from "../../../services/queries/joinCodeQueries";
import { getTeamMembersByOrganizationId } from "../../../api/teamMemberApi";
import type { Team } from "../types";

function joinCodeFromDoc(joinDoc: unknown): string | null {
  if (!joinDoc || typeof joinDoc !== "object") return null;
  const d = joinDoc as Record<string, unknown>;
  const code = d.code ?? d.joinCode;
  if (typeof code === "string" && code) return code;
  return null;
}

export type TeamDetailPanelProps = {
  team: Team;
  organizationId: string | null | undefined;
};

export const JoinCodePanel = ({
  team,
  organizationId,
}: TeamDetailPanelProps) => {
  const [joinCode, setJoinCode] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setLoading(true);
      setJoinCode(null);

      const [joinDoc, orgUsers] = await Promise.all([
        getJoinCodeByTeamId(team.id),
        organizationId
          ? getTeamMembersByOrganizationId(organizationId)
          : Promise.resolve([]),
      ]);

      if (cancelled) return;

      setJoinCode(joinCodeFromDoc(joinDoc));

      type TeamUserRow = {
        id?: string;
        uid?: string;
        email?: string;
        status?: string;
        teamId?: string;
      };

      setLoading(false);
    }

    void load();
    return () => {
      cancelled = true;
    };
  }, [team.id, team.leadUid, organizationId]);

  return (
    <>
      <div className="select-component__duration-section">
        <div className="strength-button select-component__duration-button">
          <p>{joinCode}</p>
        </div>
      </div>
    </>
  );
};
